export const boxSlotTemplateKeys = {
  all: ["boxSlotTemplate"] as const,
  slotTemplates: (boxProgramId: string) => [...boxSlotTemplateKeys.all, "slotTemplates", boxProgramId] as const,
  slotTemplate: (boxProgramId: string, slotTemplateId: string) =>
    [...boxSlotTemplateKeys.all, "slotTemplate", boxProgramId, slotTemplateId] as const,
}
